module.exports = __webpack_public_path__ + "static/media/5DPO23.c2a03227.jpg";